import { c as _c } from "react/compiler-runtime";
import { Button, Stack, Typography } from '@mui/material';
import { ConditionPanelPopover } from '@/components/conditions/conditionPanelPopover';
import { useConditionPanel } from '@/components/conditions/useConditionPanel';
import { findValueCondition } from '@/types/advanceFilter';
import { TagsCondition } from './tagsCondition';
import type { TagsConditionProps } from './tagsData';
export const TagsConditionSelector = (props: TagsConditionProps) => {
  const panel = useConditionPanel(props.panelHost, props.onPanelClose);
  const condition = findValueCondition(props.conditions, props.property.name);
  const selectedTags = condition?.value ?? [];
  return <>
      {!panel.isHosted && <Button ref={panel.triggerRef} onClick={panel.toggle} disableFocusRipple size='small' className='px-0 py-[5px]'>
          <Stack direction={'row-reverse'} className='pl-[12px] pr-[8px]' sx={{
        gap: '8px'
      }}>
            <i className='material-symbols-arrow-drop-down-rounded text-xl align-middle min-w-[22px] min-h-[22px] w-[22px] h-[22px]' />
            {selectedTags.length === 0 && <Typography variant='button' className='text-left font-medium' sx={{
          color: 'var(--mui-palette-text-disabled)'
        }}>
                Select
              </Typography>}
            {selectedTags.length > 0 && <Typography variant='button' className='text-left font-medium' sx={{
          color: 'currentcolor'
        }}>
                {selectedTags.join(', ')}
              </Typography>}
          </Stack>
        </Button>}
      <TagsConditionPanelPopover {...props} anchorEl={panel.anchorEl} popoverOpen={panel.isOpen} selectedTags={selectedTags} onChange={props.onChange} onClose={panel.close} />
    </>;
};
interface TagsConditionPanelPopoverProps extends TagsConditionProps {
  anchorEl: HTMLElement | null;
  popoverOpen: boolean;
  selectedTags: string[];
  onClose: () => void;
}
const TagsConditionPanelPopover = props => {
  const $ = _c(12);
  let t0;
  if ($[0] !== props) {
    t0 = () => props.onClose();
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== props.conditions) {
    t1 = [...props.conditions];
    $[2] = props.conditions;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== props || $[5] !== t1) {
    t2 = <Stack className="w-[308px]"><TagsCondition {...props} conditions={t1} onChange={props.onChange} /></Stack>;
    $[4] = props;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== props.anchorEl || $[8] !== props.popoverOpen || $[9] !== t0 || $[10] !== t2) {
    t3 = <ConditionPanelPopover open={props.popoverOpen} anchorEl={props.anchorEl} onClose={t0}>{t2}</ConditionPanelPopover>;
    $[7] = props.anchorEl;
    $[8] = props.popoverOpen;
    $[9] = t0;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
};